import {types} from './types';

const initialState = {
    list: {
        data: [],
        countPage: 1
    }
}

export function replenishmentReportReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_REPLENISHMENT_REPORT:
            return { ...state, list: action.payload};
        default:
            return state
    }
}